/**
 * Shared state for the platform Operations pane (header icon + docked shell).
 */

import { createContext, useContext } from 'react';

export interface OperationsPaneContextValue {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  canUse: boolean;
  /** Increments after an Operations turn or Undo so the bound page can refetch. Chat is unchanged. */
  mutationEpoch: number;
  notifyPageMutated: () => void;
}

export const OperationsPaneContext = createContext<OperationsPaneContextValue | null>(null);

export function useOperationsPane(): OperationsPaneContextValue {
  const ctx = useContext(OperationsPaneContext);
  if (!ctx) {
    return {
      isOpen: false,
      setOpen: () => undefined,
      toggle: () => undefined,
      canUse: false,
      mutationEpoch: 0,
      notifyPageMutated: () => undefined,
    };
  }
  return ctx;
}

export function isPlatformAdministratorRole(role: string | undefined): boolean {
  return role === 'Platform Administrator' || role === 'PLATFORM_ADMIN';
}
